import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c36f8b62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "breadcrumb float-right" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 首页")
const _hoisted_9 = { class: "breadcrumb-item active" }

export function render(_ctx, _cache) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "content-header-title", {}, () => [
            _createElementVNode("h1", null, [
              _createVNode(_component_svg_icon, {
                class: "nav-icon",
                name: _ctx.icon,
                width: "1.7rem",
                height: "1.7rem"
              }, null, 8, ["name"]),
              _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
            ])
          ], true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ol", _hoisted_6, [
            _renderSlot(_ctx.$slots, "content-header-breadcrumb", {}, () => [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      name: "home-outline",
                      width: "1.2rem",
                      height: "1.2rem"
                    }),
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_svg_icon, {
                  class: "nav-icon",
                  width: "1.2rem",
                  height: "1.2rem",
                  name: _ctx.icon
                }, null, 8, ["name"]),
                _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
              ])
            ], true)
          ])
        ])
      ])
    ])
  ]))
}